"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimer = void 0;
exports.getTimerDuration = getTimerDuration;
exports.getTimersFromMission = void 0;
var _general = require("./general");
/**
 * Gets the current delta clock
 * @param {?SharedMissionStateSelectorState} missionState
 * @returns {?DeltaClockData}
 */
function getDeltaState(missionState) {
  if (!missionState) {
    return null;
  }
  return missionState.deltaClock;
}

/**
 * Returns the expected duration for a timer for a given timerId.
 * Returns null if the timer could not be found
 * @param {?SharedMissionStateSelectorState}
 * @param {?timerId}
 * @returns {?number}
 */
function getTimerDuration(missionState, timerId) {
  if (!timerId) {
    return null;
  }
  let state = getDeltaState(missionState);
  if (!state) {
    return null;
  }
  let timer = state.pausedTimers[timerId];
  if (timer) {
    return timer.originalDelay;
  }
  timer = state.runningTimers.find(runningTimer => runningTimer.id === timerId);
  if (timer) {
    return timer.originalDelay;
  }
  return null;
}

/**
 * Returns a mission state selector for a delta clock Timer object given a timer Id
 * @param {?string} timerId
 * @returns {(?JuniorSharedMissionStat) => ?Timer}
 */
const getTimer = timerId => missionState => {
  if (!timerId) {
    return null;
  }
  let state = getDeltaState(missionState);
  if (!state) {
    return null;
  }
  const isMissionPaused = (0, _general.getIsPausedFromMission)(missionState) || false;
  let timer = state.pausedTimers[timerId];
  if (timer) {
    return {
      isPaused: true,
      originalDelay: timer.originalDelay,
      tag: timer.tag,
      delayLeft: timer.delay,
      currentProgress: timer.previousProgress || 0,
      id: timerId
    };
  }
  let delay = 0;
  let serializedDeltaFunction = null;
  for (let deltaFunction of state.runningTimers) {
    delay += deltaFunction.delay;
    if (deltaFunction.id === timerId) {
      serializedDeltaFunction = deltaFunction;
      break;
    }
  }
  if (!serializedDeltaFunction) {
    return null;
  }
  let delayLeft = Math.max(delay, 0);
  if (state.lastRunTime && !isMissionPaused) {
    delayLeft = Math.max(delayLeft - (Date.now() - (state.lastRunTime || 0)), 0);
  }
  const originalDelay = serializedDeltaFunction.originalDelay;
  const previousProgress = serializedDeltaFunction.previousProgress || 0;
  const tag = serializedDeltaFunction.tag;
  // Rounding current progress to precision 3 to reduce component re-renders based on millisecond changes
  const currentProgress = Number((1 - delayLeft / originalDelay * (1 - previousProgress)).toPrecision(3));
  return {
    isPaused: isMissionPaused,
    originalDelay,
    delayLeft,
    currentProgress,
    id: timerId,
    tag
  };
};
/**
 * getTimers - selector used to get a list of timers from the deltaClock
 *
 * @example useSelector(getTimers(['hello', null, 'world', undefined]))
 *
 * @param  {?Array<?string>} timerIds? - the array of timers to get, if an entry is falsy it will be ignored
 * @return { [timerId: string]: Timer } - a mapping of timerIds to the deltaClock timer progress
 */
exports.getTimer = getTimer;
const getTimersFromMission = timerIds => missionState => {
  let timers = {};
  if (!timerIds) {
    return timers;
  }
  timerIds.forEach(timerId => {
    if (!timerId) {
      return;
    }
    let timer = getTimer(timerId)(missionState);
    if (timer) {
      timers[timerId] = timer;
    }
  });
  return timers;
};
exports.getTimersFromMission = getTimersFromMission;